import styled from 'styled-components'

export const Label = styled.div`
  font-weight: bold;
`
export const ConfirmWrap = styled.div`
  label {
    font-weight: bold;
  }

  .dropdown {
    width: 100%;
    margin: 20px 0;
  }
`
export const WrapNoData = styled.div`
  backround: red;
`
export const WrapSchedule = styled.div`
  & > button {
    margin: 20px auto;
    background: #ededed;
    color: #00a8eb;
    display: block;
  }
`
export const Top = styled.div`
  display: flex;
`
export const CheckSide = styled.div`
  width: 200px;
  margin-right: 50px;
  min-height: 231px;
`
export const CheckBoxItem = styled.div`
  & > input {
    margin-right: 10px;
    position: relative;
    top: 2px;
  }
`
export const HourSide = styled.div`
  width: 200px;

  .dropdown {
    margin-bottom: 10px;

    .list {
      height: 166px;
    }

    &:nth-child(4) {
      margin-top: 30px;

      &:before {
        content: '';
        position: absolute;
        top: -16px;
        width: 100%;
        border-bottom: 1px dotted lightgrey;
      }
    }
  }
`
export const Title = styled.div`
  padding: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid lightgrey;
`
export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
`

export const TableScheduled = styled.div`
  margin-bottom: 20px;

  label {
    cursor: pointer;
    border-bottom: 1px solid lightgrey;
    width: 100%;
  }

  .table-content {
    display: table;
    width: 100%;
  }

  .table-row {
    display: table-row;

    & > div {
      display: table-cell;
    }
  }

  .table-icons {
    text-align: right;

    & > i {
      margin-right: 5px;
      cursor: pointer;
    }
  }
`
export const WrapperButtonsBetween = styled.div`
  display: flex;
  justify-content: space-between;
`
